import type { FC, ReactNode } from 'react'

import Dialog from '@reach/dialog'
import CloseIcon from 'mdi-react/CloseIcon'
import { twJoin } from 'tailwind-merge'

import '@reach/dialog/styles.css'
import './styles.scss'

const GlobalModal: FC<{
  ariaLabel: string
  children: ReactNode
  isOpen: boolean
  className?: string
  onClose?: () => void
}> = ({ children, ariaLabel, className = '', isOpen, onClose }) => (
  <Dialog
    isOpen={isOpen}
    className={twJoin('reach-ui-modal', className)}
    aria-label={ariaLabel}
    onDismiss={onClose}
  >
    <>
      {onClose && (
        <button className="close-modal-button" onClick={onClose}>
          <CloseIcon />
        </button>
      )}

      {children}
    </>
  </Dialog>
)

export default GlobalModal
